import builder from '../builder';
import HeadphonesCustomerSupportHuman1 from '../../streamline-icons/bold/headphones-customer-support-human-1.svg';

export default builder(
  'IconHeadphonesCustomerSupportHuman1Bold',
  HeadphonesCustomerSupportHuman1,
);
